import React from "react";
import { Link } from "react-router-dom";
import { useBrand } from "../../hooks/useBrand";
import { useDarkClasses } from "../../hooks/useDarkClasses";
import { useRoleTheme } from "../../hooks/useRoleTheme";
import { BoxIcon } from "lucide-react";
interface EmptyStateProps {
  icon: BoxIcon;
  title: string;
  body?: string;
  action?: {
    label: string;
    to?: string;
    onClick?: () => void;
  };
  className?: string;
}

/**
 * EmptyState — shown when a list, search or page has nothing to display.
 */
export const EmptyState: React.FC<EmptyStateProps> = ({
  icon: Icon,
  title,
  body,
  action,
  className = 'min-h-[40vh]'
}) => {
  const {
    theme
  } = useBrand();
  const dk = useDarkClasses();
  const rt = useRoleTheme();
  const buttonClass = `mt-6 inline-flex items-center px-5 py-2.5 rounded-lg text-sm font-medium transition-colors ${rt.primaryButton}`;
  return <div className={`flex flex-col items-center justify-center text-center px-4 py-12 ${className}`} data-id="element-3410" data-mp="jekhm5pyrgnz">
      <Icon className={`h-12 w-12 mb-4 ${theme.accent.icon}`} data-id="element-3411" data-mp="1qp0oj3tky1za" />
      <h2 className={`text-xl font-semibold ${dk.textHeading}`} data-id="element-3412" data-mp="1qrn51syg7rtn">{title}</h2>
      {body && <p className={`mt-2 max-w-md text-sm ${dk.textSecondary}`} data-id="element-3413" data-mp="1uqcghfzxezan">{body}</p>}
      {action && (action.to ? <Link to={action.to} className={buttonClass} data-id="element-3414" data-mp="1gzh5ny5va84f">
            {action.label}
          </Link> : <button type="button" onClick={action.onClick} className={buttonClass} data-id="element-3415" data-mp="1lx97pl087amc">
            {action.label}
          </button>)}
    </div>;
};
export default EmptyState;